import { render, staticRenderFns } from "./ProductDataHeader.vue?vue&type=template&id=c07456e4&functional=true&"
import script from "./ProductDataHeader.vue?vue&type=script&lang=js&"
export * from "./ProductDataHeader.vue?vue&type=script&lang=js&"
import style0 from "./ProductDataHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports